import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';
import { stringifyQuery } from '../../../../utils';
import isEmpty from '../../../../utils/isEmpty';
import Button from '../../../common/base/Button';
import Tabs from '../../../common/base/Tabs';
import EmptyState from '../../../common/EmptyState';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { StyledViewNavActions, StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewTitle } from '../../../layouts/ViewLayout';
import { DashboardContext } from '../DashboardContext';
import ExportDropdown from './ExportDropdown';
import MetricCategoryView, { useMetricsFilters } from './MetricCategory';
import MetricDatePicker, { DateRange, useDateRange } from './MetricDatePicker';
import { useRefreshKey } from './RefreshKeyContext';
import LINKS from '../../../../configs/links';
import ChartInteractionGroup from '../../../common/Chart/ChartInteractionGroup';
const MetricsView: React.FC = () => {
  const $ = _c(33);
  const {
    has_connection
  } = useContext(DashboardContext);
  const {
    query
  } = useSearchQuery();
  const {
    updateRefreshKey
  } = useRefreshKey();
  const [date_range, onDateRangeChanged] = useDateRange();
  const theme = useTheme();
  const {
    form,
    metric_category_key,
    metric_categories
  } = useMetricsFilters();
  const history = useHistory();
  let t0;
  if ($[0] !== metric_categories) {
    t0 = Object.entries(metric_categories).reduce(_temp, {});
    $[0] = metric_categories;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const TABS = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViewTitle title="Metrics" tooltip="Metrics allow you to track and compare request, event, and attempt activity trends on your project." link={LINKS.product_docs.metrics} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== date_range || $[4] !== onDateRangeChanged) {
    t2 = <MetricDatePicker date_range={date_range} onDateRangeChanged={onDateRangeChanged} />;
    $[3] = date_range;
    $[4] = onDateRangeChanged;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== updateRefreshKey) {
    t3 = <Button outline={true} icon="reload" onClick={() => updateRefreshKey()}>Refresh</Button>;
    $[6] = updateRefreshKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ExportDropdown />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== form || $[10] !== t2 || $[11] !== t3) {
    t5 = <StyledViewNavHeader>{t1}<StyledViewNavActions>{form}{t2}{t3}{t4}</StyledViewNavActions></StyledViewNavHeader>;
    $[9] = form;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = metric_category_key as string;
  let t7;
  if ($[13] !== history || $[14] !== query) {
    t7 = tab => {
      const query_params = !isEmpty(query?.date) ? `?${stringifyQuery({
        date: query.date
      })}` : "";
      history.push(`/metrics/${tab}${query_params}`);
    };
    $[13] = history;
    $[14] = query;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== TABS) {
    t8 = Object.values(TABS);
    $[16] = TABS;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <StyledViewNavSecondary><Tabs active_tab={t6} onTabSelected={t7} border={false} tabs={t8} /></StyledViewNavSecondary>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t9) {
    t10 = <StyledViewNav>{t5}{t9}</StyledViewNav>;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== date_range || $[26] !== has_connection || $[27] !== onDateRangeChanged || $[28] !== theme) {
    t11 = !has_connection ? <EmptyState title="Monitor event activity trends" description="Metrics allow you to track request, event, and attempt activity on your project, with export available to third-party services like Datadog & Prometheus. Metrics are only available on the Growth plan." asset={`metrics-${theme.mode}.png`} asset_position="background" cta={{
      label: "Create first connection",
      icon: "connections",
      to: "/create-first-connection"
    }} /> : <ChartInteractionGroup onTimeRangeSelected={range => onDateRangeChanged({
      relative: undefined,
      min: range.min,
      max: range.max
    })}><MetricCategoryView date_range={date_range} /></ChartInteractionGroup>;
    $[25] = date_range;
    $[26] = has_connection;
    $[27] = onDateRangeChanged;
    $[28] = theme;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <StyledViewLayout><StyledViewContent>{t10}{t11}</StyledViewContent></StyledViewLayout>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default MetricsView;
function _temp(acc, t0) {
  const [key, category] = t0;
  acc[key] = {
    label: category.label,
    icon: category.icon,
    key
  };
  return acc;
}